import React, { useEffect, Fragment, useContext } from 'react';
import { Container, Row, Col } from "reactstrap";
import { ProjectContext } from '../../../../../context/Project';
import MaterialSelection from './MaterialSelection';
import Totals from './Totals';
import Location from './Location';
import '../steps.scss';
import ContinueButton from './ContinueButton';
import FileDownloadIcon from "../../../assets/file-download.svg";
import useProjectSteps from '../../../../../hooks/useProjectSteps';
import Header from '../Header';
import { PixelContext } from '../../../../../context/Pixel';

function AddItemsStep() {
	const projectSteps = useProjectSteps();
	const { getGeneratedAiData } = useContext(ProjectContext);
	
	const projectAiData = getGeneratedAiData();
	const projectGeneratedAiImageName = projectAiData?.imageName;
	const projectGeneratedAiImageUrl = projectAiData?.imageUrl;
	const projectBom = projectAiData?.bom;
	const projectTypeId = projectBom?.projectTypeId;
	const materialSuggestions = projectBom?.aiMaterialSuggestions || [];
	const { trackAnalyticsEvent, Events } = useContext(PixelContext);

	useEffect(() => {
		const aiData = getGeneratedAiData();
		if (!aiData?.imageUrl || !aiData?.bom) {
			projectSteps.goPreviousStep();
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Fragment>
			<Header title="Step 2: Click to Add Items" progress={32}/>
			<form className="m-t-20 form-base-dis">
				{
					projectGeneratedAiImageUrl &&
					<>
						<Container className="builde-cont generated-ai-image-container">
							<Row>
								<Col className='text-center' xs={{ size: 12 }}>
									<div className='position-relative'>
										<img className='w-100' alt='' src={projectGeneratedAiImageUrl} />
										<a className='download-button btn btn-secondary' href={projectGeneratedAiImageUrl} download={projectGeneratedAiImageName} onClick={() => {
											trackAnalyticsEvent(Events.ADD_ITEMS_IMAGE_DOWNLOAD);
										}} >	
											<img src={FileDownloadIcon} alt="" />
											<span>Download</span>										
										</a>
									</div>
								</Col>
							</Row>
						</Container>
					</>
				}
				{
					projectTypeId !== undefined &&
					<Container className="builde-cont my-2">

						<MaterialSelection
							selectedType={{ id: projectTypeId }}
							selectMaterials={materialSuggestions} />

					</Container>
				}
				<Container className='builde-cont'>
					<Row>
						<Col>
							<section id="estimated-budget">
								<Totals />
							</section>
						</Col>
					</Row>
				</Container>
				{
					projectGeneratedAiImageUrl &&
					<Location />
				}
				<Container className='builde-cont'>
					<Row>
						<Col>
							<section id="estimated-budget">
								<div className="d-grid gap-2">
									<ContinueButton className="continue m-t-40 m-b-50" />
								</div>
							</section>
						</Col>
					</Row>
				</Container>
			</form>
		</Fragment>
	);
}

export default AddItemsStep;